module.exports = __webpack_public_path__ + "static/media/intercom.2bc618b3.svg";